'use strict';

import Actions from './actions';
import React from 'react';
import Signin from './sign-in';
import Register from './register';
import PropTypes from 'prop-types';

const propTypes = {
    accountOnly: PropTypes.bool,
    login: PropTypes.object,
    register: PropTypes.object,
    signinOrRegister: PropTypes.object,
    signinComplete: PropTypes.func,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    autoLoginAfterRegister: PropTypes.bool
};

class SignInOrRegister extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};
    }

    signin(event) {

        event.preventDefault();
        Actions.signin();
    }

    register(event) {

        event.preventDefault();
        Actions.register();
    }

    recover(){
        Actions.forgot();
    }

    render() {

        const activeRegister = this.props.signinOrRegister.choice_register ? 'active' : '';
        const activeSignin = this.props.signinOrRegister.choice_register ? '' : 'active';
        const body = this.props.signinOrRegister.choice_register ? (
            ( <Register
                accountOnly={this.props.accountOnly}
                cancel={this.props.cancel}
                autoLoginAfterRegister={this.props.autoLoginAfterRegister}
                signin={Actions.signin} recover={this.recover} {...this.props.register} /> )
        ) :
            ( <Signin cancel={this.props.cancel} signinComplete={this.props.signinComplete} {...this.props.login} /> );

        const registerLink = !this.props.login.success ? (
            <a onClick={this.register.bind(this)} href="#">Create Account</a>
        ) : (
            <a href="#">Create Account</a>
        );

        const signinLink = !this.props.login.success ? (
            <a onClick={this.signin.bind(this)} href="#">Sign In</a>
        ) : (
            <a href="#">Sign In</a>
        );

        return (
            <section className="sor">
                <h3 className="text-center">{this.props.title}</h3>
                <p className="text-center sign-in-or-register-text">{this.props.subTitle}</p>
                <ul className="nav nav-tabs">
                    <li role="presentation" className={activeRegister}>{registerLink}</li>
                    <li role="presentation" className={activeSignin}>{signinLink}</li>
                </ul>
                {body}
            </section>
        );
    }
}

SignInOrRegister.propTypes = propTypes;

export default SignInOrRegister;
